<template>
    <el-select v-model="selectedUser" :placeholder="placeholder" @change="handleChange">
        <el-option v-if="isSearchModel" label="すべて" :value="ALL"/>
        <el-option v-for="item in users" :key="item.user_code" :label="item.user_name" :value="item.user_code" />
    </el-select>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, watch } from 'vue';
import axios from 'axios';
import { UserInfo } from '../models/userinfo';
import { ALL } from '@/config/constants';

export default defineComponent({
    name: 'UserSelector',
    props: {
        isSearch: {
            type: Boolean,
            default: false,
        },
        company_code: {
            type: String,
            required: true,
        },
        modelValue: {
            type: String,
            default: ALL,
        },
        placeholder: {
            type: String,
            default: 'ユーザー名を選択してください',
        },
    },

    emits: ['update:modelValue', 'change'],

    setup(props, { emit }) {
        const users = ref<UserInfo[]>([]);
        const selectedUser = ref(props.modelValue);
        const isSearchModel = ref(props.isSearch);

        onMounted(() => {
            if (!props.company_code) {
                users.value = [];
                return;
            }
            fetchUsers();
        });


        watch(() => props.company_code, async (newValue, oldValue) => {
            if (newValue === oldValue) return;
            // 清空用户列表
            users.value = [];
            // 保存旧的modelValue
            const oldModelValue = props.modelValue;

            if (newValue) {
                // 获取新的用户列表
                await fetchUsers();

                // 如果旧的modelValue存在，则检查新的用户列表中是否包含旧的modelValue对应的用户
                if (oldModelValue) {
                    const userExists = users.value.some(user => user.user_code === oldModelValue);
                    if (userExists) {
                        // 如果存在，则设置选中值
                        selectedUser.value = oldModelValue;
                        emit('update:modelValue', oldModelValue);
                    } else {
                        // 如果不存在，则清空选中值
                        selectedUser.value = isSearchModel.value ? ALL : '';
                        emit('update:modelValue', isSearchModel.value ? ALL : '');
                    }
                } else {
                    // 如果旧的modelValue不存在，则清空选中值
                    selectedUser.value = isSearchModel.value ? ALL : '';
                    emit('update:modelValue', isSearchModel.value ? ALL : '');
                }
            }

        });

        watch(() => props.modelValue, (newValue) => {
            // 只有当新值与当前选中值不同时才更新
            if (selectedUser.value !== newValue) {
                selectedUser.value = newValue;
            }
        });

        const handleChange = (value: string) => {
            emit('update:modelValue', value);
            emit('change', value);
        };

        const fetchUsers = async () => {
            try {
                const response = await axios.get(`/api/users?company_code=${props.company_code}`);
                users.value = response.data.data;
                // 确保在获取数据后更新选中值
                if (props.modelValue && !selectedUser.value) {
                    selectedUser.value = props.modelValue;
                }
            } catch (error) {
                // console.error('获取ユーザー列表失败:', error);
            }
        };


        return {
            users,
            selectedUser,
            handleChange,
            ALL,
            isSearchModel,
        };
    },
});
</script>